/**
 * @file visibility.js
 * @location src/utils/visibility.js
 * @role 업무 가시성 공통 헬퍼 — 전체 업무(ManagerTasksPage) + 알림벨(useNotificationInboxes) 공용 단일 진입점
 *
 *  단일 매니저 팀(razor ⑲) — 부서 없음:
 *    매니저(canSeeAllTasks)  → 전사 (제한 없음, null)
 *    팀원(그 외)        → 본인만
 *
 *  getVisibleMemberIds(S) → Set<uid> | null   (null = 제한 없음 = 전사)
 *  filterVisibleTasks(tasks, visibleSet)
 */
import { canSeeAllTasks } from './permissions.js';

export function getVisibleMemberIds(S) {
  const me = S.members.find(m => m.id === S.uid);
  if (!me) return new Set([S.uid]);
  // 단일 매니저 팀: 매니저 = 전사, 팀원 = 본인만
  if (canSeeAllTasks(me)) return null;
  return new Set([me.id]);
}

export function filterVisibleTasks(tasks, visibleSet) {
  if (!visibleSet) return tasks;
  return tasks.filter(t => visibleSet.has(t.aee));
}
